import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { TitleBar, IconCheck, IconClose } from '../common/theme';
import { generatePassword, getCreateUserStatus, getCreateFeildStatus } from '../../ApiHelper';
import { toArray } from '../../Utils';
import Spinner from '../common/generic/Spinner';

const BulkStudentComp = ({pageState}) => {
    const [newStudents, setNewStudents] = useState([]);
    const [studentTextArea, setStudentTextArea] = useState('');   
    const [loginNameRadio, setLoginNameRadio] = useState('1');
    const [passwordsRadio, setPasswordsRadio] = useState('1');
    const [passwordsNumChars, setPasswordsNumChars] = useState(4);
    const [passwordsDefault, setPasswordsDefault] = useState('');
    const [useLetters, setUseLetters] = useState(true);
    const [useNumbers, setUseNumbers] = useState(true);
    const [showVerified, setShowVerified] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [createStudentsDisabled, setCreateStudentsDisabled] = useState(true);
    const [numErrors,setNumErrors] = useState(0);

    const verifyClicked = () =>{

        let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
        let currentLimit = pageState.database['userLimit'];

        let allStudents = toArray(pageState.database['getStudentsForClass'].data);
        let shouldDisableButton = true;
        let errorCount = 0;
        let nameLines = studentTextArea
            .split('\n') // split by line break
            .map(e=>e.trim()) // remove white space
            .filter(e=>e) // remove empty lines
            .filter((val,id,array) => array.indexOf(val) == id) // remove duplicates
            .map(name=>{ // add passwords and logins

                let pass = generatePassword(passwordsNumChars,useLetters,useNumbers);
                pass = (passwordsRadio === '2') ? passwordsDefault : pass;  
                pass = (passwordsRadio === '3') ? '' : pass;  

                let login = name;
                let nameParts = name.split(' ');
                if(loginNameRadio === '2') login = nameParts[0];
                if(loginNameRadio === '3') login = nameParts[nameParts.length-1];
                if(loginNameRadio === '4') login = nameParts[0]+((nameParts.length > 1) ? nameParts[nameParts.length-1].charAt(0) : '');

                let statusName = getCreateUserStatus('Name',name,true,allStudents.map(e=>e.Name));
                let statusLogin = getCreateUserStatus('Username',login,true,allStudents.map(e=>e.CompareName));
                let statusPass = getCreateFeildStatus('Password',pass,false);

                let status = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';

                if(status === 'ok') currentNumStudents++;
                if(currentNumStudents > currentLimit && currentLimit!==-1){
                    if(status === 'ok') 
                        status = 'Exceeded Limit';
                }
                if(status === 'ok') shouldDisableButton = false;
                if(status !== 'ok') errorCount++;
                return {name, login, pass, type:status};
            }
        );
        setCreateStudentsDisabled(shouldDisableButton);
        setNumErrors(errorCount);

        // find duplicate login names
        let loginNames = nameLines.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id) ;
        nameLines = nameLines.map(studentRec=>{ // give an error for duplicate login names
            if(loginNames.indexOf(studentRec.login) > -1)
                studentRec.type ='Username already taken';
            return studentRec;
        });

        setNewStudents(nameLines);    
        setShowVerified(true);
    };

    const saveStudents=()=>{
        let saveChanges = [];

        newStudents.forEach((studentRec, i) => {
            let {name, login, pass, type} = studentRec;
            if(type!=='ok') return;

            let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
            let schoolID = pageState.database['getCustomer'].data['ID'];
            let classID = pageState.showStudentTableComp.classInfo.ClassID;

            let query = {
                params: `${schoolID}~${classID}~${name}~${login}~${pass}~0~0`,
                altName: 'addStudents',
                func:'addStudent', 
            };
            if(prevQuery !== 'undefinded')
                query.nextRequest = prevQuery;
            saveChanges.push(query);
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSaving(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;

            let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
            pageState.database['getCustomer'].data['NumStudents'] = (currentNumStudents + counter)+'';

            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }        
    };

    useEffect(()=>{
        if(pageState.showBulkStudentComp){
            setShowVerified(false);
            setStudentTextArea('');
            setNewStudents([]);
        }
    },[pageState.showBulkStudentComp]);

    // Check when saving has completed by wating for database.queryCount to become 0
    // UPDATES - database.queryCount changes -&&- only when saving
    useEffect(()=>{
        if(isSaving){
            if(pageState.database.queryCount == 0){
                setIsSaving(false);
                setShowVerified(false);
                setNewStudents([]);
                setStudentTextArea('');                
                // pageState.deleteThis('getStudentsForClass');  
                pageState.showStudentScreen(pageState.showStudentTableComp.classInfo);               
            }
        }
    },[pageState.database.queryCount]);

    if(isSaving) return <> <Spinner/> <center><h1>Processing...({pageState.database['queryCount']})</h1></center></>;
    
    return((!pageState.showBulkStudentComp)?<></>:<>
        <TitleBar>
            <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Add a list of Students</h3></Col>
            <Col xs='4'>
                <span className={'pull-right'}>
                    <Button variant="danger" onClick={()=>{ setStudentTextArea(''); setShowVerified(false); pageState.showAddUserScreen('Student');}}>Cancel</Button> &nbsp;
                </span>
            </Col>
        </TitleBar>
        <br/>
        {!showVerified ? <>
            <Alert variant='warning'>
                <h4> Instructions </h4>
                <p> Type or cut and paste a list of student names into the box below. Next choose how you want to generate their login names and passwords.  Press <strong>Verify</strong> to check for possible errors or conficts.  When satisfied, press the <strong>Add Students</strong> button to create the students.</p>
            </Alert>

            <Row>
                <Col  xs='4'>
                    <Row>
                        Type or paste a list of Student Names
                    </Row>
                    <div className="form-group">
                        <Row>
                            <textarea style={{resize: 'none'}} className="form-control textFont" rows="10" id="studNameList" onChange={e => setStudentTextArea(e.target.value)} value={studentTextArea}></textarea>
                        </Row>
                    </div>
                </Col>

                <Col xs='4'>
                    <TitleBar>
                        <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Usernames</h3></Col>
                    </TitleBar>

                    <Row style={{height:'228px', backgroundColor:'#efefff', borderStyle: 'solid', borderWidth: '1px', borderColor: '#bfbfbf', paddingLeft:'10px'}}>
                    <Col xs='12'>
                        <Row><Col xs='12'>&nbsp;</Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '1'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="1" type="radio" name="loginradio" />&nbsp;Full Names</label></Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '2'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="2" type="radio" name="loginradio"/>&nbsp;First Names</label></Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '3'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="3" type="radio" name="loginradio"/>&nbsp;Last Names</label></Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '4'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="4" type="radio" name="loginradio"/>&nbsp;First Name + First Letter of Last Name</label></Col></Row>
                        <Row><Col xs='12'>&nbsp;</Col></Row>
                        </Col>
                    </Row>
                    <Row><Col xs='12'>&nbsp;</Col></Row>
                </Col>

                <Col xs='4'>
                    <TitleBar>
                        <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Passwords</h3></Col>
                    </TitleBar>

                    <Row style={{height:'228px',backgroundColor:'#efefff', borderStyle: 'solid', borderWidth: '1px', borderColor: '#bfbfbf', paddingLeft:'10px'}}>
                        <Col xs='12'>
                            <Row><Col xs='12'>&nbsp;</Col></Row>
                            <Row style={{textAlign: 'center'}}>
                                <Col xs='12'>
                                <label><input checked={passwordsRadio === '1'} onChange={(e)=>setPasswordsRadio(e.target.value)} value="1" type="radio" name="passradio"/>&nbsp;Generated</label>&nbsp;&nbsp;&nbsp;
                                <label><input checked={passwordsRadio === '2'} onChange={(e)=>setPasswordsRadio(e.target.value)} value="2" type="radio" name="passradio"/>&nbsp;Single</label>&nbsp;&nbsp;&nbsp;
                                <label><input checked={passwordsRadio === '3'} onChange={(e)=>setPasswordsRadio(e.target.value)} value="3" type="radio" name="passradio"/>&nbsp;None</label></Col>
                            </Row>
                            <Row><Col xs='12'>&nbsp;</Col></Row>
                            {(passwordsRadio === '1')&&<>
                                <Row>                   
                                    <Col xs='12' className="form-group">
                                        <label style={{float:'left', marginRight:'5px', marginTop:'5px'}}>Number of Characters:</label>&nbsp;&nbsp;
                                        <input type="text" size="4" onChange={(e)=>setPasswordsNumChars(e.target.value)} value={passwordsNumChars}/>
                                    </Col>
                                </Row> 
                                <Row><Col xs='12'>&nbsp;</Col></Row>
                                <Row style={{textAlign: 'center'}}>                   
                                    <Col xs='6'>
                                        <input checked={useLetters} onChange={(e)=>setUseLetters(e.target.checked)} type="checkbox" className="form-check-input" /> <label htmlFor="name">Use Letters</label>
                                    </Col>
                                    <Col xs='6'>
                                        <input checked={useNumbers} onChange={(e)=>setUseNumbers(e.target.checked)} type="checkbox" className="form-check-input" /> <label htmlFor="name">Use Numbers</label>
                                    </Col>
                                </Row> 
                            </>}

                            {(passwordsRadio === '2')&&
                                <Row>                   
                                    <Col xs='12' className="form-group">
                                        <center><label style={{float:'left', marginRight:'5px', marginTop:'5px'}}>Password:</label><br/>
                                        <input type="text" onChange={(e)=>setPasswordsDefault(e.target.value)} value={passwordsDefault}/></center>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                    <Row><Col xs='12'>&nbsp;</Col></Row>
                </Col>
            </Row>    
            <Row>
                <Col xs='12'>
                    <span className={'pull-right'}>
                        <Button onClick={verifyClicked} disabled={studentTextArea.length===0} variant="success">Verify</Button> &nbsp;
                    </span>
                </Col>
            </Row>    
        </>:<>
            <Row><Col xs='12'>
                <div style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
                    {titleRow}
                    {newStudents.map((student, i) => 
                        <VerifyRow key={i} data={student} />
                    )}
                </div>
            </Col></Row>

            <Row>
                <Col xs='12'>
                    <Button onClick={saveStudents} disabled={createStudentsDisabled} variant="success">Confirm</Button> &nbsp;
                    <Button onClick={()=>{setStudentTextArea(''); setShowVerified(false); pageState.showAddUserScreen('Student');}} disabled={createStudentsDisabled} variant="danger">Cancel</Button> &nbsp;
                    <Button onClick={()=>{setShowVerified(false);}} variant="warning">Retry</Button> &nbsp;
                    {(numErrors>0) && <span style={{color:'red'}}>&nbsp; {numErrors} Errors found (Errors will not be included)</span> }
                </Col>
            </Row>    
        </>}
    </>);
};

const verifyColor = (type) => (type==='ok') ? {backgroundColor:'lightgreen'} : {backgroundColor:'#FFAfAF'};

const VerifyRow = ({data}) => <Row style={verifyColor(data.type)} >
        <Col style={{textAlign: 'left'}} xs='3'>{data.type!=='ok' &&  <IconClose/>}{data.type==='ok' &&  <IconCheck/>} {data.name}</Col>
        <Col style={{textAlign: 'left'}} xs='3'>{data.login}</Col>
        <Col style={{textAlign: 'left'}} xs='3'>{data.pass}</Col>
        <Col style={{textAlign: 'left'}} xs='3'>{data.type}</Col>
    </Row>;

const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='3'>Name</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Username</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Password</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Problem</Col>
    </Row>;

export default BulkStudentComp;